/* eslint-disable */
import React from 'react'
import Modal from 'react-modal';
import styled from 'styled-components';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const WrapperTitle = styled.div`
 font-size:20px;
 color: #42526E;
  font-weight:600;
  margin-bottom:14px;
`;

const WrapperWording = styled.div`
 font-size:16px;
 color: #42526E;
  font-weight:500;
  margin:0 auto 30px;
  width:80%;
`;
function ModalCustom(props) {

  const {
    isOpenModal,
    setOpenModal,
    title,
    wording,
    action1,
    action2,
    handleSaveAction,
    isInfoSelected,
    classNames
  } = props;

  function closeModal() {
    setOpenModal(false)
  }

  function handleSaveModal(){
    handleSaveAction(isInfoSelected)
    setOpenModal(false)
  }

  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
      <div 
        className={`d-flex justify-content-between flex-column ${classNames ? classNames : 'mw-400'}`}
        >
      <div className='text-center'>
        <WrapperTitle>{title}</WrapperTitle>
        <WrapperWording>{wording}</WrapperWording>
      </div>
      <div className='d-flex align-items-center justify-content-center'>
        <div onClick={closeModal} className='me-3 btn-secondary'>
          <h5 className="fw-bold btn-generate">
            {action1}
          </h5>
        </div>
        <div onClick={handleSaveModal} className='btn-generate-report'>
          <h5 className="fw-bold btn-generate">
            {action2}
          </h5>
        </div>
      </div>
      </div>
       
      </Modal>
    </div>
  )
}

export default ModalCustom